<template>
    <Dialog
        v-model:visible="layoutState.searchBarActive"
        :breakpoints="{ '992px': '75vw', '576px': '90vw' }"
        modal
        dismissableMask
        @show="focusOnInput"
        :pt="{
            root: 'w-1/2 overflow-hidden!',
            header: 'hidden!',
            content: 'p-0!'
        }"
    >
        <div class="search-container">
            <i class="pi pi-search" />
            <!-- the same hint as the search box on the Customers list, which receives the text -->
            <InputText
                v-model="criteria"
                type="text"
                class="p-inputtext search-input"
                ref="searchInput"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
                placeholder="Reference, name, e-mail, phone, postcode, EAN, device id"
                title="Search customers on reference, name, e-mail, phone, postcode, EAN or device id"
                @keydown.enter="search"
            />
        </div>
    </Dialog>
</template>

<script setup>
import { useLayout } from '@/layout/composables/layout';
import { onKeyStroke } from '@vueuse/core';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const { layoutState } = useLayout();
const router = useRouter();

const searchInput = ref(null);
const criteria = ref('');

//Ctrl+K, or Cmd+K on macOS, opens the search from any screen, also while an input has focus;
//preventDefault keeps the browser from taking the keystroke for its own address bar
onKeyStroke(['k', 'K'], (event) => {
    if (!event.ctrlKey && !event.metaKey) return;
    event.preventDefault();
    layoutState.searchBarActive = true;
});

//the search always lands on all customers with only the search text, so no filter left over from
//an earlier visit hides a match; the list reads the text from the route and reloads on it
function search() {
    const text = criteria.value.trim();
    layoutState.searchBarActive = false;
    if (text) router.push({ name: 'customers-all', query: { criteria: text } });
}

//the box opens empty, also after it was closed with Esc halfway through typing
function focusOnInput() {
    criteria.value = '';
    searchInput.value.$el.focus();
}
</script>
